import { useReducer, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import queryString from "query-string"
import { reducer } from "./reducer"
import {
  setSearchParams,
  setRequestResult,
  setSideArticles,
} from "./actionCreators"
import articleServices from "../../../services/articleServices"
import { paths } from "../../../routes/paths"

const useSearch = () => {
  const history = useHistory()
  const location = useLocation()
  const locationSearchGroup = queryString.parse(location.search)
  const [state, dispatch] = useReducer(reducer, {
    searchParamGroup: {
      query: "",
      ...locationSearchGroup,
    },
    requestResultGroup: {
      itemList: [],
      itemCount: 0,
      pageCount: 0,
      isFetching: true,
    },
    sideArticleGroup: {
      type: locationSearchGroup.query ? "popular" : "recent",
      itemList: [],
    },
  })
  useEffect(() => {
    const locationSearchGroup = queryString.parse(location.search)
    dispatch(setSearchParams(locationSearchGroup))
    articleServices
      .getInstituteArticlePage(locationSearchGroup)
      .then(({ data }) => {
        dispatch(setRequestResult(data, locationSearchGroup))
        window.scrollTo(0, 0)
      })
    if (locationSearchGroup.query) {
      articleServices.getInstituteArticlePage({}).then(({ data }) => {
        dispatch(setSideArticles(true, data.institute_articles))
      })
    } else {
      articleServices.getRecentInstituteArticles().then(({ data }) => {
        dispatch(setSideArticles(false, data?.institute_articles))
      })
    }
  }, [location.search])
  useEffect(() => {
    history.replace(paths.instituteSearch(state.searchParamGroup))
  }, [state.searchParamGroup])
  return [state, dispatch]
}
export default useSearch
